import React from 'react';
import { TextButton } from '@oneaudi/unified-web-components';
import { dynamicStylingHelper } from '../../../../utils/AlphaHelper';
const GetButton = ({ buttonInfo, variant, trackButtonClick, isMobileScreenSize, isLoading, }) => {
    var _a;
    const { label, url, target, type } = buttonInfo;
    const htmlTarget = target === 'new-window' ? '_blank' : '_self';
    return (React.createElement(TextButton, { "aria-label": (_a = buttonInfo.ariaLabel) !== null && _a !== void 0 ? _a : label, variant: variant, href: url, target: htmlTarget, "data-testid": `${type}-button-variant-${variant}`, "data-tracking-exclude": true, isFullWidth: isMobileScreenSize, isLoading: isLoading, onClick: () => {
            trackButtonClick(buttonInfo, variant, buttonInfo.trackingCode);
        }, size: dynamicStylingHelper('md', 'sm') }, label));
};
export default GetButton;
